import React from 'react'
import './Home.css'

function Home() {
  return (

    <div className='home'>
      <h1> 
      <label  id='descStu'>About Our Mission</label>
      <p id='description'>We aim to cultivate a vibrant and inclusive student community 
      by providing a centralized platform for students to discover events, mentoring opportunities, 
      and student organizations tailored to their interests and aspirations. Our website serves as a 
      hub for students to voice their ideas, engage in diverse learning experiences, and find their place 
      within the University community, empowering them to thrive and 
      contribute to campus life. </p>
      </h1>
    </div>
  )
}

export default Home

